import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@/_services';

import type { LoginApiErrorResponse, LoginApiResponse, LoginHandlerParams } from './types';

export type LoginApiPayload = {
  username: string;
  password: string;
  checked?: boolean;
};

export const useLoginMutation = ({ onSuccess, onError }: LoginHandlerParams) => {
  const { mutateAsync: login, isPending: isLoading } = useMutation<
    LoginApiResponse,
    LoginApiErrorResponse,
    LoginApiPayload
  >({
    mutationFn: (payload) =>
      apiClient.post({
        endpoint: '/token/',
        payload,
        isAuth: false,
      }),
    onSuccess,
    onError,
  });

  return { login, isLoading };
};
